import { capitalizeStr } from '$shared/helpers';

export const FormFields = ['firstName', 'lastName', 'yearOfBirth'] as const;

export const events = {
  fieldEnter: Object.fromEntries(
    FormFields.map((field: string) => [field, `${capitalizeStr(field)}Enter`])
  ),
} as const;
